<template>
  <div :class="[{'group-left': groupId !== undefined}]">
    <template v-for="option in ((model.invalidConfig && model.invalidConfig.optionList) ? model.invalidConfig.optionList : config.optionList)">
      <div
        v-if="isOther ? (option.optionGroupId === 99999 && option.visibility) : (groupId === undefined || (groupId !== undefined && groupId === option.optionGroupId)) && option.visibility"
        :key="option.id"
        class="option-item"
        @click="selectItem(option)"
      >
        <template v-if="multiple">
          <el-checkbox v-if="show" :value="isSelected(option)" :disabled="option.disabled ? true : false">
            <answer-lang :text="option.displayTitle"></answer-lang>
          </el-checkbox>
        </template>
        <template v-else>
          <el-radio :value="isSelected(option)" :label="true" :disabled="option.disabled ? true : false">
            <answer-lang :text="option.displayTitle"></answer-lang>
          </el-radio>
          <el-row v-if="config.answerConfig.isShowVotingScore === '1'" class="progress-bar-container">
            <el-progress :stroke-width="7" :text-inside="true" :percentage="option.percentage" :format="format" :color="progressColor"></el-progress>
            <div class="bottom">
              <div class="item left-item">
                {{option.votes}}{{cvtLang('tipsVote', config.tipsVote)}}
              </div>
              <div class="item right-item">
                {{option.rate}}%
              </div>
            </div>
          </el-row>
        </template>
        <template v-if="option.type !== 'other'">
          <div v-if="option.imgUrl" class="medio-main">
            <ipsos-av v-if="isAv(option.imgUrl)" :src="option.imgUrl"></ipsos-av>
            <ipsos-image v-else :imgUrl="option.imgUrl" :preview="option.id"></ipsos-image>
          </div>
        </template>
        <template v-else>
          <div v-if="option.imgUrl" class="medio-main">
            <ipsos-av v-if="isAv(option.imgUrl)" :src="option.imgUrl"></ipsos-av>
            <ipsos-image v-else :imgUrl="option.imgUrl" :preview="option.id"></ipsos-image>
          </div>
          <div @click.stop>
            <Input
              v-show="isSelected(option)"
              class="textarea"
              v-model="option.otherValue"
              type="textarea"
              :autosize="{minRows: 3,maxRows: 5}"
              :maxlength="200"
              style="margin-top:10px;"
            />
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AnswerOptionSingleMobile',
  props: [
    'config',
    'model',
    'optionValueKey',
    'multiple',
    'groupId',
    'isOther',
    'cvtLang'
  ],
  data () {
    return {
      show: true,
      progressColor: '#38ADAB',
    }
  },
  watch: {
    'model.invalidConfig.type' (newVal) {
      if (newVal) {
        // reset value
        this.model.invalidConfig.optionIds.forEach(id => {
          const optionItem = this.model.invalidConfig.optionList.find(item => item.optionName === id)
          if (optionItem) {
            this.$set(optionItem, 'disabled', 1)
          }
          this.model.value = ''
        })
      } else {
        if (this.model.invalidConfig) {
          this.model.invalidConfig.optionList.forEach(item => {
            item.disabled = 0
          })
        }
      }
    }
  },
  computed: {
  },
  methods: {
    isAv (url) {
      return url && url.includes('.mp4')
    },
    selectItem (option) {
      if (option.disabled) {return}
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)

      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
      return this.$emit('selectItem', option)
    },
    isSelected (option) {
      const { multiple, model } = this
      const { selectedValue, value } = this.getValue(option)
      if (multiple) {
        return value.includes(selectedValue)
      }
      return model.value === selectedValue
    },
    getValue (option) {
      const { model, optionValueKey } = this
      const selectedValue = option[optionValueKey]
      const value = model.value
      return {
        selectedValue,
        value
      }
    },
    format(){
      return '';
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.group-left {
  margin-left: 20px;
}
.option-item {
  padding: 28px 0;
  border-bottom: 1px solid #F1F1F1;
  display: flex;
  flex-direction: column;

  >>> .el-radio, >>> .el-checkbox {
    line-height: 48px;
    margin-right: 20px;
    display: flex;
    .el-radio__inner, .el-checkbox__inner {
      width: 30px;
      height: 30px;
      position: relative;
      top: 8px;
      box-shadow:0 0 0 0 !important;
    }
    .el-radio__inner::after {
      width: 7px;
      height: 7px;
    }
    .el-checkbox__inner::after {
      width: 8px;
      height: 16px;
      margin-left: 5px;
      border-width: 2px;
    }
    .el-radio__label, .el-checkbox__label {
      margin-left: 8px;
      line-height: 44px;
    }
  }
  .medio-main {
    display: flex;
    justify-content: center;
    img {
      max-width: 100%;
      display: table;
      margin: 0 auto;
    }
  }
}
.progress-bar-container {
  .bottom {
    display: flex;
    justify-content: space-between;
    .item {
      font-size: 24px;
      line-height: 44px;
    }
    .left-item {
      color: #808695;
    }
    .right-item {
      color: #26BFAD;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerOptionSingleMobile.vue